module.exports = __webpack_public_path__ + "img/tab-main.8a4ac8f.8a4ac8fa.png";